export const informationalPopoverMotion = {
    initial: { opacity: 0, y: 20 },
    animate: {
        opacity: [0, 1],
        y: [20, 0],
        transition: {
            duration: 0.3,
            ease: 'easeInOut',
        },
    },
};
